import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
  Colors,
  helperButtonReset,
  helperLinkReset,
  helperListItemHover,
  helperTypographyText,
} from '@utex/ui-kit';
import { SizeType, ViewType } from '.';

import arrow from './static/img/arrow.svg';

export const Container = styled('div')`
  margin-bottom: 1rem;
`;

interface ItemProps {
  view?: ViewType;
  size?: SizeType;
  href?: string;
  target?: string;
  isExpand?: boolean;
  isOpen?: boolean;
  isActive?: boolean;
}

export const Item = styled('a')<ItemProps>`
  ${helperButtonReset};
  ${helperLinkReset};
  display: block;
  width: 100%;
  position: relative;
  padding: 1rem 2.4rem;
  text-align: left;
  line-height: 1;
  cursor: ${(props) => (props.isActive ? 'default' : 'pointer')};

  ${(props) => helperTypographyText({ size: props.size, view: props.view })};

  ${(props) =>
    !props.isActive &&
    helperListItemHover({
      activeBgColor: Colors.ut.listItemDown,
    })};

  ${(props) =>
    props.isActive &&
    css`
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 0.4rem;
        border-radius: 0 0.4rem 0.4rem 0;
        background-color: ${Colors.ut.alert};
      }
    `};

  ${(props) =>
    props.isExpand &&
    css`
      padding-right: 3.2rem;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        right: 2.4rem;
        width: 0.8rem;
        height: 100%;
        background: url(${arrow}) center no-repeat;
        background-size: 0.8rem 1.3rem;
        transform: ${props.isOpen && 'rotate(90deg)'};
        transition: transform 0.3s;
      }
    `};
`;

export const Wrapper = styled('div')`
  display: flex;
`;

export const ItemSecond = styled('a')`
  display: block;
  padding: 0.7rem 2.4rem 0.7rem 6.9rem;
  font-size: 1.3rem;
  line-height: 1.69;

  ${helperLinkReset};

  &[href] {
    ${helperListItemHover({
      activeBgColor: Colors.ut.listItemDown,
    })};
  }

  &:not([href]) {
    cursor: default;
    color: ${Colors.text.disabled};
  }
`;

export const Icon = styled('div')`
  flex-shrink: 0;
  margin-right: 2.1rem;
  opacity: 0.8;
`;
